const NHAN = {
  moi_tao: { label: "Mới tạo", color: "secondary" },
  dang_thu_mua: { label: "Đang thu mua", color: "info" },
  gan_day: { label: "Gần đầy", color: "warning" },
  da_day: { label: "Đã đầy", color: "error" },
  da_dong: { label: "Đã đóng", color: "dark" },
  da_nhap_kho: { label: "Đã nhập kho", color: "success" },
};

export function nhanTrangThaiSot(trangThai) {
  return NHAN[trangThai] ?? { label: trangThai, color: "secondary" };
}

const NHAN_HINH_THUC_TT = {
  tien_mat: "success",
  chuyen_khoan: "info",
  cong_no: "warning",
};

export function mauHinhThucTt(ma) {
  return NHAN_HINH_THUC_TT[ma] ?? "secondary";
}
